import { all } from 'redux-saga/effects';

import addIndividualContractWatcher from './contract-detail-saga';

export default function* rootSaga(action) {
	yield all([addIndividualContractWatcher(action)]);
}
